import * as THREE from "three";

export function createLabel(text, options = {}) {

  const {
    fontSize = 12,
    width = 8,
    height = 2,
    position = new THREE.Vector3(0, -0.3, 0.3),
    rotationX = -30
  } = options;

  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  canvas.width = 700;
  canvas.height = 128;

  ctx.font = `900 ${fontSize}px Roboto`;
  ctx.fillStyle = "#000000";
  ctx.shadowColor = "rgb(255,255,255)";
  ctx.shadowBlur = 6;
  ctx.shadowOffsetX = 4;
  ctx.shadowOffsetY = 4;
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";

  ctx.fillText(text, canvas.width / 2, canvas.height / 2);

  const texture = new THREE.CanvasTexture(canvas);

  const geometry = new THREE.PlaneGeometry(width, height);

  const material = new THREE.MeshBasicMaterial({
    map: texture,
    transparent: true,
    depthWrite: false,
    depthTest: false
  });

  const plane = new THREE.Mesh(geometry, material);
  plane.renderOrder = 1000;
  plane.rotation.x = THREE.MathUtils.degToRad(rotationX);
  plane.position.copy(position);

  return plane;
}